export const Bed: React.FC<React.SVGAttributes<{}>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="currentColor"
    {...props}
  >
    <path
      id="Bed"
      d="M228.5,466.75V455.5A7.5,7.5,0,0,0,221,448H191a7.5,7.5,0,0,0-7.5,7.5v11.25L176,491.125v11.25a1.874,1.874,0,0,0,1.875,1.875h3.75V508H183.5v-3.75h45V508h1.875v-3.75h3.75A1.874,1.874,0,0,0,236,502.375v-11.25ZM185.375,455.5A5.632,5.632,0,0,1,191,449.875h30a5.632,5.632,0,0,1,5.625,5.625v11.1q-.938-.072-1.875-.137V463a3.75,3.75,0,0,0-3.75-3.75h-9.375a3.75,3.75,0,0,0-3.75,3.75v2.824c-.625,0-1.25-.009-1.875-.009s-1.25,0-1.875.009V463a3.75,3.75,0,0,0-3.75-3.75H191a3.75,3.75,0,0,0-3.75,3.75v3.467q-.938.065-1.875.137Zm37.5,10.84q-6.557-.409-13.125-.5V463a1.877,1.877,0,0,1,1.875-1.875H221A1.877,1.877,0,0,1,222.875,463Zm-33.75,0V463A1.877,1.877,0,0,1,191,461.125h9.375A1.877,1.877,0,0,1,202.25,463v2.843Q195.684,465.933,189.125,466.34Zm-4.207,2.176c6.992-.549,14.077-.827,21.082-.827s14.09.277,21.082.827l6.331,20.576c-9.1-.517-18.313-.779-27.413-.779s-18.308.262-27.413.779Zm49.207,33.859h-56.25v-11.36q14.05-.823,28.125-.827t28.125.827Z"
      transform="translate(-176 -448)"
      fill="#212121"
    />
  </svg>
);
